import createHistory from 'history/createBrowserHistory'
import { setupStore as setupStoreDev } from './setupStore.dev'
import { setupStore as setupStoreProd } from './setupStore.prod'

// console.log( `setupStore: `, setupStore )
// TODO
// Add environment specific setore setup logic here

export const history = createHistory()

const setupStore = process.env.NODE_ENV === 'production' ? setupStoreProd : setupStoreDev
export const store = setupStore(history)


// WEBPACK FOOTER //
// ./src/store/index.ts